import Period from "./Period";
import Day from "./Day";

export default class WorkingTime {
  periods = [];

  constructor(periods) {
    periods.map((p) => {
      this.periods.push(new Period(p.period, p.days));
    });
  }

  static getWeekDays(locale = "pt-br") {
    const baseDate = new Date(Date.UTC(2017, 0, 1));
    return Array(7)
      .fill(0)
      .map(() => {
        const dayName = baseDate.toLocaleDateString(locale, {
          weekday: "long",
          timeZone: "UTC",
        });
        baseDate.setDate(baseDate.getDate() + 1);
        return dayName.charAt(0).toUpperCase() + dayName.slice(1);
      });
  }

  static getTemplatePeriodWeek(periodName = null, active = true) {
    return new Period(
      periodName,
      Array(7)
        .fill(0)
        .map((item, index) => {
          return new Day(index + 1, null, null, active, false, null);
        })
    );
  }

  toJSON() {
    return this.periods;
  }
}
